import * as React from 'react'
import './style.less'
import {Surface} from 'telstra-ui/components/surface/Surface'
import {SurfaceList} from 'telstra-ui/components/list/List'
import {SvgIcon} from 'telstra-ui/components/svg/Icon'
import { isStoreIntAvailable } from '@applications/self-service-store'

interface IMDUMCardErrorBoundaryState {
  hasError: boolean
  isMobileView: boolean
}

interface IMDUMCardErrorBoundaryProps {
  children?: React.ReactNode
}

export class StoreCardErrorBoundary extends React.Component<
  IMDUMCardErrorBoundaryProps,
  IMDUMCardErrorBoundaryState
> {
  public windowSize
  constructor(props) {
    super(props)
    this.windowSize = window.innerWidth

    this.state = {hasError: false, isMobileView: false}
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true}
  }
  public componentDidMount() {
    window.addEventListener('resize', this.handleResize, true)
  }

  public handleResize = () => {
     /* istanbul ignore else */
    if (window.innerWidth >= 768) {
      this.setState({isMobileView: false})
    } else {
      this.setState({isMobileView: true})
    }
  }
  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, true)
  }

  private errorTitle = 'Telstra Connect Store'
  private handleErrorCallback = () => window.location.reload()

  private renderErrorHeader = (
    <div
      className="tl-heading__container"
      style={{cursor: 'initial'}}
      id="ui-mobility-card-error-heading"
    >
      <div className="__heading">{this.errorTitle}</div>
    </div>
  )

  private renderErrorBody = (
    <div className="tc-mobility-card-error">
      <div className="tc-mobility-card-error__body">
        <SvgIcon
          name={'picto-empty-state'}
          className="tc-telstra-icon tc-mobility-card-error__body__icon"
        />
        <div className="tc-mobility-card-error__body__icon__error" id="ui-mobility-card-error-text">
          {'Loading error'}
        </div>
        <div
          className="tc-mobility-card-error__body__icon__text"
          id="ui-mobility-card-error-subtext"
        >
          There was an error loading this app.
        </div>
      </div>
    </div>
  )

  private renderErrorFooter = (
    <div
      id="ui-mobility-card-refresh"
      className="tc-mobility-card-error__button tl-list-im-button"
      onClick={this.handleErrorCallback}
    >
      <SvgIcon
        name={'icon-system-refresh'}
        className="tc-footer-refresh-icon"
        id="ui-mobility-card-refresh-icon"
      />
      <span className="tc-footer-text" id="ui-mobility-card-refresh-text">
        Refresh
      </span>
    </div>
  )

  render() {
    const cardHeight = this.state.isMobileView ? {height: '480px'} : {height: '424px'}
    if (this.state.hasError) {
      return (
        <div
          className="tc-mobility-services-container"
          style={isStoreIntAvailable() ? cardHeight : {height: '320px'}}
        >
          <Surface
            className="tl-custom-width tl-surface-dashboard ui-card-error"
            name="surface-flat"
          >
            <div className="tl-card-inner-content">
              <SurfaceList
                header={this.renderErrorHeader}
                body={<>{this.renderErrorBody}</>}
                footer={this.renderErrorFooter}
              />
            </div>
          </Surface>
        </div>
      )
    }

    return this.props.children
  }
}
